import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MyButton from '../utils/MyButton'
import MyTextField from '../utils/MyTextField'


import { getArrayYears, applyMaskAmount, applyMaskAccount } from '../utils/utils';
import UnoButton from '../utils/UnoButton';

import { Typography } from '@material-ui/core';

import { unoTheme, myLabelInput } from '../../assets/styles/unoTheme'

import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

import moment from 'moment'
// const Transition = React.forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
// });

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
    },

    // dialogContent: {
    //     display: 'flex',
    //     background: "#eeeeee",
    //     alignItems: 'center',
    //     flexDirection: 'column',
    // },

    actionsFlex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },

    actionsFlexRight: {
        display: 'flex',
        alignItems: 'center',
    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },
    formControl: {
        //margin: theme.spacing(1), 
        width: '100%',
        textAlign: 'left'
    },
    dialogTitle: {
        '& h2': {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            //justifyContent: 'space-between'
        }

    },
    noMarginTop: {
        marginTop: "0px",
    },
    tableTh: {
        fontWeight: 'bold'
    },
    assetsToCreateRow: {
        '& .MuiTableCell-root': {
            fontSize: '12px !important',
        }
    },
    green: {
        color: unoTheme.greenMoney,
    },
    red: {
        color: unoTheme.redMoney,
    },
    blue: {
        color: "blue",
    },
    warningColor: {
        color: unoTheme.warningColor
    },
    label: myLabelInput,
    afirmativeText: {
        color: 'black'
    },
    noPaddingLeft: {
        paddingLeft: '0px',
    },
    noPaddingRight: {
        paddingRight: '0px !important',
    },


}));

export default function ConfirmBatchAprModal(props) {

    const { open,
        handleAction } = props;

    const classes = useStyles();

    useEffect(() => {

    }, [])

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'sm'}
            open={open}
            onClose={() => handleAction(false)}>
            <DialogTitle
                className={classes.dialogTitle}>
                Gerar Lote de APRs
            </DialogTitle>

            <DialogContent
                className={classes.dialogContent}>

                <Typography style={{ textAlign: 'center' }}>
                    Escolha como quer exibir as informações da GESTÃO
                </Typography>

            </DialogContent>


            <DialogActions className={classes.actionsFlex}>

                <UnoButton onClick={() =>
                    handleAction(false)} color="secondary">
                    Cancelar
                </UnoButton>
                <div>

                    <UnoButton
                        className={classes.spaceRight2}
                        onClick={() => handleAction(true, false)}
                        color="primary"
                        startIcon={<VisibilityIcon />}>
                        Exibir CPF's
                    </UnoButton>

                    <UnoButton
                        className={classes.spaceRight2}
                        onClick={() => handleAction(true, true)}
                        color="primary"
                        startIcon={<VisibilityOffIcon />}>
                        Não Exibir CPF's
                    </UnoButton>
                </div>


            </DialogActions>



        </Dialog >
    );
}